import { render, staticRenderFns } from "./MarkAsRead.vue?vue&type=template&id=37ffc5e5&scoped=true&"
import script from "./MarkAsRead.vue?vue&type=script&lang=js&"
export * from "./MarkAsRead.vue?vue&type=script&lang=js&"
import style0 from "./MarkAsRead.vue?vue&type=style&index=0&id=37ffc5e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ffc5e5",
  null
  
)

export default component.exports